//WILL NEED TO CHANGE STUFF HERE!!
const LOCATION = process.env.REACT_APP_LOCATION;

if (!LOCATION) {
    throw new Error('REACT_APP_LOCATION is not set. The application cannot function without a valid location.');
  }

const RLM_CATEGORIES = ['1', '10.0', '11', '12', '13', '14', '15', '16.0', '17', '18', '19', '2', '20.0', '20.1.0', '20.1.1.0', '20.1.2.0', '20.1.3.0', '20.2', '20.3', '20.4', '20.5', '20.6.1', '20.6.2', '21.0', '22.1', '22.2', '23.0', '24.0', '24.1', '24.2', '24.3', '24.4', '24.5', '24.6.0', '24.6.1', '24.6.2', '24.6.3', '24.7.0', '24.7.1', '24.7.2', '24.7.3', '24.7.4', '24.7.5', '25', '26', '27', '28', '29', '3.0', '30.1', '30.2', '31', '32', '33.0', '33.1', '33.2', '33.3.0', '33.3.1', '33.3.2', '33.4', '33.5', '33.6', '33.7', '34', '35.0', '35.1.1', '35.1.2', '35.1.3', '35.1.4', '35.1.5', '35.2', '35.3', '35.4', '35.5', '35.6', '35.7.0', '35.7.1', '35.7.2', '35.7.3', '35.7.4', '35.8', '36', '37', '38', '39', '4.0', '40.0', '40.1.0', '40.1.1', '40.1.2', '40.2', '41.0', '42', '43.0', '43.1', '43.2', '43.3', '43.4', '43.5', '43.6', '43.7', '43.8', '43.9', '44.0', '45.0', '45.1', '45.2', '45.3', '45.4', '46', '47', '48.0', '49', '5.0', '50', '51.1', '51.2', '52', '53', '54.0', '54.1.0', '54.10.0', '54.11', '54.12', '54.13', '54.14', '54.15', '54.16', '54.17', '54.18', '54.2', '54.3', '54.4', '54.5.0', '54.6', '54.7', '54.8', '54.9', '55.0', '55.1', '55.10.0', '55.10.1', '55.10.2', '55.11.0', '55.11.1.0', '55.11.2', '55.2.0', '55.2.1', '55.2.2', '55.3', '55.4.0', '55.5.0', '55.5.1', '55.5.2', '55.6.0', '55.6.1', '55.6.2', '55.7', '55.8', '55.9.0', '55.9.1', '55.9.2', '55.9.3', '56.0', '56.1', '56.10', '56.11', '56.12', '56.13', '56.14', '56.15', '56.16', '56.17', '56.18', '56.19', '56.2', '56.20', '56.21.0', '56.22', '56.23', '56.24', '56.25', '56.26', '56.27', '56.3', '56.4', '56.5', '56.6', '56.7', '56.8', '56.9', '57.0', '57.1.0', '57.1.1', '57.1.2', '57.1.3', '57.10.0', '57.11.0', '57.11.1.0', '57.11.2', '57.11.3', '57.12.0', '57.12.1.0', '57.12.2', '57.12.3.0', '57.12.4', '57.13.1', '57.13.2', '57.13.3.0', '57.13.4', '57.14.0', '57.14.1', '57.14.2', '57.14.3', '57.14.4', '57.14.5', '57.14.6', '57.14.7', '57.2.0', '57.2.1', '57.2.2', '57.2.3', '57.3.0', '57.4', '57.5', '57.6.0', '57.6.1', '57.6.2', '57.6.3', '57.6.4.0', '57.7.0', '57.7.1', '57.7.2', '57.7.3', '57.8.0', '57.8.1', '57.8.2', '57.8.3', '57.9.0', '57.9.1.0', '57.9.2.0', '57.9.3', '57.9.4', '58.0', '58.1.0', '58.1.1', '58.1.2', '58.1.3.0', '58.10', '58.11.0', '58.12.0', '58.12.1', '58.12.2.0', '58.12.3.0', '58.13.0', '58.13.1', '58.13.2', '58.13.3', '58.14', '58.2', '58.3.0', '58.3.1', '58.3.2', '58.4.0', '58.4.1', '58.4.2', '58.5.0', '58.6.0', '58.6.1', '58.6.2', '58.6.3', '58.7.0', '58.7.1', '58.7.2', '58.8.0', '58.8.1', '58.8.2', '58.8.3', '58.9.0', '59', '6.0', '6.1', '6.2.0', '6.2.1', '6.2.2', '6.3.1', '6.3.2', '6.4.0', '6.4.1', '6.4.2', '6.5', '6.6.0', '6.6.1', '6.6.2', '6.7', '60.0', '60.1', '60.10', '60.11.0', '60.11.1', '60.11.2', '60.12', '60.13', '60.14', '60.15', '60.16', '60.17', '60.18', '60.2', '60.3.0', '60.4.0', '60.5.0', '60.6', '60.7', '60.8', '60.9.0', '60.9.1', '60.9.2', '60.9.3', '61.0', '61.1', '61.10.0', '61.10.1', '61.10.2', '61.10.3', '61.2.1', '61.2.2', '61.3.0', '61.3.1', '61.3.2', '61.4.0', '61.4.1', '61.4.2.0', '61.5', '61.6.0', '61.6.1', '61.6.2', '61.7.1.0', '61.7.1.1', '61.7.1.2', '61.7.2.0', '61.7.2.1', '61.7.2.2', '61.8.0', '61.9.0', '61.9.1', '61.9.2', '61.9.3', '61.9.4.0', '61.9.5', '62.1', '62.2.0', '62.3.0', '62.3.1', '62.3.2', '62.4', '62.5', '63.1', '63.2', '63.3', '63.4', '63.5', '63.6', '63.7', '64.0', '65.0', '65.1', '65.10', '65.11', '65.12', '65.13', '65.14', '65.15', '65.16', '65.17', '65.18', '65.19', '65.2', '65.20', '65.21', '65.22', '65.23', '65.24', '65.25', '65.26', '65.27', '65.3', '65.4', '65.5.0', '65.5.1', '65.5.2', '65.5.3', '65.6', '65.7', '65.8', '65.9', '66.0', '66.1', '66.10', '66.11', '66.12', '66.13', '66.14', '66.15', '66.16.0', '66.17', '66.18', '66.19', '66.2', '66.20', '66.21', '66.22', '66.23', '66.24', '66.25.0', '66.25.1', '66.25.2', '66.3', '66.4', '66.5', '66.6', '66.7', '66.8', '66.9', '67.0', '67.1', '67.2.0', '67.2.1', '67.2.2', '67.2.3', '67.2.4', '67.3.0', '67.3.1', '67.3.2', '67.3.3', '67.3.4', '67.3.5', '67.4', '67.5.0', '67.5.1', '67.5.2', '67.5.3', '67.5.4', '67.5.5', '67.5.6', '67.6.0', '67.6.1', '67.6.2', '67.6.3', '67.6.4', '67.6.5', '67.7.0', '67.7.1', '67.7.10', '67.7.11', '67.7.2', '67.7.3', '67.7.4', '67.7.5', '67.7.6', '67.7.7', '67.7.8', '67.7.9', '67.8', '68.0', '68.1', '68.10.0', '68.10.1', '68.10.2', '68.11.0', '68.11.1', '68.11.2', '68.12', '68.13.0', '68.13.1', '68.13.2', '68.13.3', '68.14', '68.15.0', '68.15.1', '68.15.2', '68.2.0', '68.2.1', '68.2.2', '68.2.3', '68.3', '68.4.0', '68.4.1.0', '68.4.1.1', '68.4.1.2', '68.4.2.0', '68.4.2.1', '68.4.2.2', '68.4.2.3', '68.5', '68.6.0', '68.6.1', '68.6.2', '68.7', '68.8.0', '68.8.1', '68.8.2', '68.8.3', '68.9.0', '68.9.1', '68.9.2', '68.9.3', '69.0', '69.1', '69.10.0', '69.10.1', '69.10.2.1', '69.10.2.2', '69.11.0', '69.11.1.0', '69.11.2', '69.11.3', '69.2', '69.3', '69.4.0', '69.4.1', '69.4.2', '69.5', '69.6.0', '69.6.1.1', '69.6.1.2', '69.6.1.3', '69.6.2', '69.7.0', '69.7.1.0', '69.7.1.1', '69.7.1.2', '69.7.1.3', '69.7.2', '69.8.0', '69.8.1', '69.8.2', '69.9', '7.0', '70.0', '70.1', '70.10', '70.11', '70.12', '70.13', '70.14.0', '70.14.1', '70.14.2', '70.15', '70.16', '70.17', '70.18', '70.19.0', '70.19.1', '70.19.2', '70.19.3', '70.2', '70.20', '70.21', '70.22.0', '70.22.1', '70.22.2', '70.23', '70.24', '70.3', '70.4', '70.5', '70.6', '70.7', '70.8', '70.9', '71.0', '71.1', '71.2.0', '71.3', '71.4', '71.5', '71.6', '71.7', '71.8', '71.9.0', '71.9.1', '71.9.2', '72.0', '72.1', '72.10.0', '72.10.1', '72.10.2', '72.11.0', '72.11.1.0', '72.11.2', '72.11.3', '72.12', '72.13.0', '72.13.1', '72.13.2', '72.2.0', '72.2.1', '72.2.2.0', '72.2.2.1', '72.2.2.2', '72.2.2.3', '72.3.0', '72.3.1.0', '72.3.1.1', '72.3.1.2', '72.3.1.3', '72.3.1.4', '72.3.2', '72.4', '72.5.0', '72.5.1', '72.5.2', '72.5.3', '72.5.4', '72.6', '72.7', '72.8.0', '72.8.1', '72.8.2', '72.9.0', '72.9.1', '72.9.2', '72.9.3.0', '72.9.3.1', '72.9.3.2', '73.0', '73.1.0', '73.1.1', '73.1.2', '73.10.0', '73.10.1', '73.10.2', '73.11.0', '73.11.1', '73.11.2', '73.11.3', '73.11.4', '73.11.5', '73.12', '73.13', '73.14.0', '73.14.1', '73.14.2', '73.14.3', '73.14.4', '73.15', '73.16.0', '73.16.1', '73.16.2', '73.17.0', '73.17.1', '73.17.2', '73.17.3', '73.17.4', '73.17.5', '73.17.6', '73.2.0', '73.2.1', '73.2.2', '73.3', '73.4.0', '73.4.1', '73.4.2', '73.4.3.0', '73.5.0', '73.5.1', '73.5.2', '73.5.3', '73.5.4', '73.6', '73.7', '73.8', '73.9.0', '73.9.1', '73.9.2', '73.9.3', '73.9.4', '73.9.5', '74.0', '74.1', '74.2', '74.3', '74.4', '74.5', '74.6', '75.1', '75.2', '76.1', '76.2', '76.3', '8.0', '9.0', '_other'];
const RLM_Cabinet_CATEGORIES = ['55.0', '56.0', '57.0', '58.0', '60.0', '61.0', '65.0', '66.0', '67.0', '68.0', '69.0', '70.0', '71.0', '72.0', '73.0', '_other'];
const RLM_orangepot_CATEGORIES = ['56.1', '56.14', '56.19', '56.2', '56.25', '56.27', '56.4', '56.8', '56.9', '65.1', '65.10', '65.11', '65.12', '65.19', '65.2', '65.20', '65.21', '65.22', '65.3', '65.6', '65.7', '65.8', '65.9', '66.1', '66.14', '66.2', '66.22', '66.24', '66.4', '66.5', '68.4.1.2', '70.1', '70.10', '70.11', '70.12', '70.13', '70.14.0', '70.14.1', '70.14.2', '70.15', '70.16', '70.17', '70.18', '70.2', '70.22.1', '70.22.2', '70.23', '70.3', '70.4', '70.5', '70.6', '70.7', '70.8', '70.9', '71.4', '71.9.1', '72.1', '72.9.1', '_other'];
const RLM_blackpot_CATEGORIES = ['56.10', '56.11', '56.12', '56.13', '56.15', '56.16', '56.17', '56.20', '56.22', '56.24', '56.26', '56.5', '56.7', '65.14', '65.27', '66.10', '66.11', '66.12', '66.13', '66.15', '66.16.0', '66.17', '66.18', '66.19', '66.20', '66.21', '66.23', '66.3', '66.6', '66.7', '66.9', '69.2', '70.20', '71.5', '71.6', '72.9.2', '_other'];
const RLM_figure_CATEGORIES = ['1', '50', '59', '_other'];
const RLM_signage_CATEGORIES = ['10.0', '11', '12', '13', '16.0a', '16.0b', '2', '21.0a', '21.0b', '22.2', '29', '3.0', '30.1', '4.0a', '4.0b', '42', '43.1', '5.0a', '5.0b', '51.1', '7.0a', '7.0b', '7.0c', '8.0a', '8.0b', '8.0c', '9.0a', '9.0b', '_other'];
const SL_CATEGORIES = ['1.1', '1.10', '1.11', '1.13', '1.14', '1.15', '1.16', '1.17', '1.2.1', '1.2.2', '1.20', '1.3', '1.4.1', '1.4.2', '1.4.3', '1.4.4', '1.5', '1.7', '1.8', '1.9', '2.1.0', '2.1.1', '2.1.3', '2.10.1', '2.10.2', '2.10.3', '2.11', '2.12', '2.13.1', '2.13.2', '2.13.3', '2.13.4', '2.13.5', '2.14.1', '2.14.2', '2.14.3', '2.15', '2.17', '2.18', '2.19', '2.2', '2.20', '2.21.0', '2.21.2', '2.21.3', '2.22', '2.23.0', '2.23.2', '2.23.3', '2.23.5', '2.23.6', '2.23.7', '2.23.8', '2.25', '2.26', '2.27.1', '2.27.2', '2.3', '2.4', '2.5', '2.6', '2.7', '2.8.1', '2.8.2', '2.8.3', '2.9', '3.10', '3.11', '3.12.0', '3.12.3', '3.13', '3.14', '3.15.1', '3.15.2', '3.15.3', '3.15.4', '3.15.5', '3.16.0', '3.16.2', '3.17.0', '3.17.2', '3.18.1', '3.18.2', '3.18.3', '3.2.0', '3.3.0', '3.3.2', '3.4.0', '3.4.2', '3.7.0', '3.8', '3.9', '3.9.1', '3.9.4', '_other'];
const MT_CATEGORIES = ['1', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '2', '20', '21', '22', '23', '24', '25', '26.0', '26.1', '26.2', '26.3', '26.4', '27', '28', '29', '3', '30', '31', '32', '33', '34', '35', '36', '37', '38.0', '38.1', '38.2', '39', '4', '40', '41', '42', '43.0', '43.1', '43.2', '43.3', '43.4', '44.0', '44.1', '44.2', '45', '46', '47', '48', '49', '5.0', '5.1', '5.2', '5.3', '5.4', '50', '6', '7', '8', '9', '_end', '_other'];
const NMC_CATEGORIES = ['1.0', '1.1', '1.10', '1.11', '1.12', '1.13', '1.14', '1.15', '1.16', '1.17', '1.18', '1.19', '1.2', '1.20', '1.21', '1.22.0', '1.22.1.1', '1.22.1.2.0', '1.22.2.1.0', '1.22.2.2.0', '1.22.2.3', '1.22.2.4', '1.22.3.1.0', '1.22.3.2.0', '1.22.3.2.1', '1.22.3.2.2', '1.22.3.2.3', '1.22.3.2.4', '1.23', '1.24.0', '1.24.1.1', '1.24.1.2', '1.24.1.3', '1.24.1.4', '1.24.2.1', '1.24.2.2', '1.24.2.3', '1.24.2.4.0', '1.24.2.4.1', '1.24.2.4.2', '1.24.3.1', '1.24.3.2', '1.24.3.3', '1.24.3.4', '1.24.4', '1.24.7.2', '1.24.7.4', '1.24.7.5', '1.25', '1.26', '1.27.0', '1.27.1', '1.27.2', '1.29', '1.3', '1.30', '1.31', '1.32', '1.33', '1.34', '1.35.0', '1.35.1', '1.35.2', '1.35.3.0', '1.36', '1.37', '1.38', '1.39', '1.4', '1.40', '1.41', '1.42', '1.43', '1.44', '1.45', '1.46.0', '1.46.1.1', '1.46.1.2', '1.46.1.3', '1.46.1.4.0', '1.46.1.5.1', '1.46.1.5.2', '1.46.2.1.0', '1.46.2.2', '1.46.2.3', '1.46.2.4', '1.46.2.6', '1.46.2.8', '1.46.3.1', '1.46.3.2', '1.46.3.3', '1.46.3.4', '1.47', '1.48', '1.49.0', '1.49.1.1', '1.49.1.2.0', '1.49.1.3', '1.49.1.4', '1.49.1.5', '1.49.2.1', '1.49.2.2', '1.49.2.3.0', '1.49.2.4', '1.49.2.5', '1.49.2.6', '1.49.3.1.0', '1.49.3.2', '1.49.3.3.0', '1.5', '1.50.1', '1.50.2', '1.50.3', '1.51', '1.52', '1.53', '1.54', '1.55', '1.56', '1.57', '1.58', '1.59', '1.6', '1.60', '1.61', '1.7', '1.8', '1.9', '_other'];
const TT_CATEGORIES = ['1', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '2.0', '2.1.0', '2.1.1', '2.1.2', '2.1.3', '2.1.4', '2.2.0', '2.2.1', '2.2.2', '2.2.3', '2.3.0', '2.3.1', '2.3.2', '2.4', '20.0', '20.1', '20.2', '21', '22.0', '22.1', '22.10', '22.11', '22.12', '22.13', '22.14', '22.15', '22.2', '22.3', '22.4', '22.5', '22.6', '22.7', '22.8', '22.9', '3', '4', '5.0', '5.1', '5.10', '5.11', '5.12', '5.13', '5.14', '5.15', '5.16', '5.17', '5.18', '5.19', '5.2', '5.20', '5.21', '5.22', '5.3', '5.4', '5.5', '5.6', '5.7', '5.8', '5.9', '6', '7', '8', '9', '_other'];
const RAMM_CATEGORIES = ['1.1.0', '1.1.1', '1.1.2', '1.1.3.0', '1.1.3.1', '1.1.3.2', '1.1.3.3', '1.1.3.4', '1.1.3.5', '1.1.4', '1.1.5', '1.1.6', '1.1.7.0', '1.1.7.1', '1.1.7.2', '1.1.8', '1.2.1', '1.2.10', '1.2.2', '1.2.3.0', '1.2.3.1', '1.2.3.2', '1.2.4', '1.2.5', '1.2.6', '1.2.7', '1.2.8.0', '1.2.8.1', '1.2.8.2', '1.2.9', '1.3', '1.4.0', '1.4.1', '1.4.2', '2.1.1.1', '2.1.1.2', '2.1.2', '3.1', '3.2.1', '3.2.2', '4.1', '4.2', '4.3', '4.4.0', '4.4.1', '4.4.2', '4.4.3', '4.4.4', '5.1', '_other'];

const RLM_TITLES = [
        'Rufinius Primus',
        'Legio II Augusta',
        'Legionaries on the march',
        'Battle commences',
        'Auxiliary cavalry pursues the retreating enemy',
        'Aurelius Herculanus - Horseman',
        '[Matu]rius [Fus]cus - Beneficiarius',
        'A Roman Legion',
        'Titus Flavius Candidus - Legionary',
        'Quintus Julius Severus - Veteran',
        'Gaius Valerius Victor - Standard-bearer',
        'The Roman Army',
        'Pay and Coinage',
        '',
        '1 Aureus and 25 Denarii',
        '1 Denarii and 4 Sestertii',
        '1 Sestertius and 2 Dupondii and 3 Asses',
        'Later developments',
        'Local enterprise',
        'Gloria Exercitvs - The Glory of the Army',
        'The Caerwent Siliqua Hoard',
        'Savings',
        'Locally made money-pot',
        'Isca: The Legionary Fortress',
        'Dedication to the Emperor Trajan',
        'Dedication to the Emperor Trajan',
        'A Soldiers Savings? - The Llanvaches Coin Hoard',
        'Image and Identity',
        'Silver tip from a legionary banner',
        'Bronze cooking-pan (trulleus)',
        'Part of a wooden writing-tablet inscribed in ink',
        'Neck of a wine amphora addressed to the legion',
        'Bronze leaf-stop from an imposing monumental inscription',
        'Fragments of imperial statues',
        'Metal lappet (pteryx) from the armoured skirt',
        'Bronze finger',
        'Bronze finger',
        'Coins of the Roman Empire',
        'Denarius of Vespasian (69-79)',
        'As of Hadrian',
        'Sestertius of Hadrian',
        'Sestertius of Antoninus Pius',
        'Denarii of the deified Antoninus Pius',
        'Caracalla',
        'Valerian and Gallienus',
        'Septimius Severus, Caracalla and Geta',
        'Ornamental Screen',
        'Building at the Fortress',
        'Tombstones',
        'Century of Rufinius',
        'Century of Rufinius',
        'Tombstone for Aurelia',
        'Septimius Severus, Caracalla and Geta',
        'Earliest archaeological museum catalogue from Wales',
        'Title page',
        'Brick Inscribed LEG-II-AVG',
        'Roman bricks',
        'Roman brick',
        'Roman brick',
        'Francis Godwin',
        'Bishop Godwins Inscriptions Book',
        'Roman Coin Plate',
        'Isca Silurum Catalogue',
        'Temple of Mithras',
        'Religion and Superstition',
        'Dolphins (symbols of prosperity), and rosette',
        'Cupid riding two dolphins',
        'Gorgon head with celestial symbols',
        'Head, probably of Mercury',
        'Head, possibly of Venus',
        'Statuette of a Genius Togatus',
        'Statue of a genius - a presiding spirit',
        'Leaden curse',
        'Miniature alter',
        'Small figurine of a ram',
        'Pipe-clay figurines',
        'Venus Figurine (Lower Part)',
        'Dedication to Mercury',
        'Dedication to Fortuna and Bonus Eventus',
        'Temple of Diana',
        'Altar to Salus',
        'Funerary Monument',
        'Britannia',
        'Funerary objects',
        'Funerary Head of Attis',
        'Funerary head',
        'Funerary head',
        'Ovoid Finial',
        'Cremation Burial',
        'Death and Burial',
        'The Great Bulmore Gravestones',
        'The Great Bulmore Gravestones',
        'Gravestone of Julius Valens',
        'Gravestone of Julia Secundina',
        'Gravestone of Julia Veneria',
        'Gravestone of Julia Iberna',
        'Gravestone of Caesoria Coro[ti]ca',
        'Gravestone of Julia Nundina',
        'Gravestone of Julia Senica',
        'Gravestone of Gaius Julius Decuminus',
        'Relief of a Dog and a Lion',
        'Querns',
        'Quern',
        'Quern',
        'Quern',
        'Quern',
        'Fistula',
        'Labyrinth mosaic',
        'Amphorae',
        'The Goldcliff Stone',
        'Early Campaigns in Wales',
        'Gaius Valerius Victor',
        'On the Map ',
        'Interactive section',
        'Gravestone of Tadia Vallaunius and Tadius Exuperatus',
        'A Family Reunited? - Gravestone of Sanctinius Exsuperatus',
        'Decorative objects',
        'Glass bangles and beads',
        'Trumpet-brooches',
        'Tinned bronze brooch with trumpet scrolls',
        'T-shaped brooch, enamelled bronze',
        'Trumpet-brooch, enamelled bronze',
        'Dolphin-brooch',
        'One-piece brooch',
        'Tapering bow-brooches',
        'Hod Hill type brooch, tinned bronze',
        'Fan-tailed brooches',
        'Bronze mount',
        'Figurine of a banqueter',
        'Ox-head mount',
        'Bronze keys',
        'Handle from a shallow bowl',
        'Tinned bronze plaque',
        'Bronze strigil (body scraper)',
        'Enamelled bronze disc-brooch',
        'Military Equipment',
        'Bronze cooking pan (trulleus)',
        '',
        'Iron mail armour',
        'Bronze hook from a mail shirt',
        '',
        'Feathered scale armour',
        'Bone belt-buckle',
        'Dagger and scabbards',
        'Dagger in iron scabbard',
        'Iron dagger-scabbard',
        'Iron frying pan',
        'Lead baggage-labels',
        '',
        'Bronze folding foot-rule',
        'Bronze dividers',
        '',
        'Silvered bronze seal-box lid',
        'Enamelled bronze harness-stud',
        'Mortarium (food-mixing bowl)',
        'Iron linch-pin',
        '',
        'Bronze terret ring',
        'Bronze harness-ring',
        'Bronze bell',
        'Usk Pottery A.D. 55-75',
        'Flagon',
        'Cooking Jar',
        'Jar',
        'Cooking Jar',
        'Cooking Jar',
        'Cooking Jar',
        'Jar',
        'Jar',
        'Jar',
        'Cheese-press',
        'Samian bowl ',
        'Flagon',
        'Roughcast beaker',
        'Colour-coated cups',
        'Oil lamp filler or feeding cup',
        'Cup',
        'Cup',
        'Beaker',
        'Pot-lid',
        'Olive-oil amphora',
        'Pottery human nose',
        'Two-handed flagon',
        'Two-handed flagon',
        'Dish',
        'Bowl',
        'Tazza',
        'Mortarium',
        'Jewellery and Dress',
        'Bracelets',
        'Bracelets',
        'Bracelets',
        'Bracelets',
        'Cloak-pin',
        'Fasteners for clothing',
        'Button and loop fasteners of bone and bronze',
        'Enamelled bronze dress fasteners',
        'Dress hooks',
        '',
        'Cows teeth pendants',
        'Jet pendant',
        'Jet beads',
        'Amber beads',
        'Glass beads',
        'Glass beads for necklaces',
        'Bone beads',
        'Gold-in-glass bead',
        'Ear-rings and necklaces',
        'Gold pendant',
        'Silver pendant in the form of an acorn',
        'Gold ear-ring',
        'Garnet drop ear-ring',
        'Emerald bead',
        'Cornelian bead',
        'Part of a gold necklet',
        'Finger-rings',
        'Gilt bronze ring',
        'Silver ring-setting with bust of Saturn',
        'Rings of glass, jet, bronze and silver',
        'Bone and bronze hair pins',
        'Bone pin-head in form of female bust',
        'Fragment of white bronze mirrors',
        'Bow hrooches',
        'Trumpet brooches',
        'Tapering bow brooches',
        'Doiphin brooch',
        'Enamelled bronze bow brooches',
        'Brooches from 2nd-3rd century AD',
        'Knee brooches',
        'Disc brooches',
        'Penannular brooches',
        'Brooches from late 2nd-3rd century AD',
        'Tinned bronze bow brooch',
        'Divided bow brooch',
        'Crossbow brooch',
        'Enamelled bronze disc and plate brooches',
        'Disc brooches',
        'Plate brooches in form of sandals',
        'Plate brooch in form of a boar',
        'Plate brooch in form of a fly',
        'Military Fittings',
        '',
        'Glass beads',
        'Crescentic pendants',
        '',
        'Enamelled bronze belt and buckle-plates',
        'Bone and bronze scabbard-chapes (terminals)',
        '',
        'Belt terminal',
        'Hangers for strap ends',
        'Hangers in the form of Hercules club',
        '',
        'Belt-plate',
        'Belt-plate',
        'Belt-plates and mountings',
        'Leaden baggage labels',
        'Bronze and enamelled bronze - strap union links',
        '',
        'Bronze mounting from a sword scabbard',
        'Bronze scabbard plate',
        '',
        'Bronze belt-loops from sword-scabbards',
        'Tinned bronze plaque',
        'Iron linch pins',
        'Horse equipment',
        'Iron horseshoe',
        'Bronze boss from horse-harness',
        'Bronze head-stall',
        '',
        'Roundel with phallus',
        'Bone harness fitting',
        '',
        'Bronze belt-buckles',
        'Bone buckle-loop',
        'Bronze belt-buckle',
        'Enamelled bronze belt-buckles',
        '',
        'Valerius Martialis',
        'Glassware',
        'Mould-blown bowl',
        'Flasks',
        'Flask',
        'Flask',
        'Mould-blown bottle ',
        'Cast of the base (of bottle above)',
        'Flask and beaker',
        'Flask',
        'Beaker',
        'Head of Medusa',
        'Fragments of moulded bowls',
        'A',
        'B',
        'Fragment of a flask',
        'Arms and Armour',
        'Iron legionary helmet',
        'Iron shield-mounting',
        '',
        'Clay sling-shot',
        'Ballista balls',
        'Natural pebbles',
        'Spearheads',
        'Javelin (pilum) heads',
        'Pike head',
        'Part of a bronze mask from a parade helmet',
        'Bronze plaque decorated with',
        'Bronze apron fittings',
        'Bronze cheek-piece from a legionary helmet',
        'Helmet carrying handles',
        'Bronze fittings from plate armour (lorica segmentata)',
        'Bronze and iron mail armour (lorica hamata)',
        'Bronze scale armour (lorica squamata)',
        '',
        'Antler stiffeners for composite bows',
        '',
        'Arrowheads',
        'Caltrops',
        'Ballista (catapult) bolts',
        'Tools and Industry',
        'Iron axe',
        '',
        'Bronze ferrule',
        'Leaden plumb-bob',
        'Bronze folding foot-rule',
        'Masons tools',
        'Masons tools',
        '',
        'Masons trowel',
        'Leaden plumb-bob',
        '',
        'Wall-painting',
        'Wall-painting',
        'Masons square',
        'Leather working',
        'Knife for cutting leather',
        'Leather seams and off-cuts',
        'Carpenters tools',
        'Socketed gouge',
        'Firmer chisel',
        'Carpenters tools',
        'Blade from a plane',
        'Socketed wood-axe',
        'Tile stamps of the Second',
        'Metalworking',
        'Blacksmiths hammer',
        'Blacksmiths light tongs',
        'Armourers hammer',
        'Metalworking crucibles',
        'Clay casting-mould',
        'Box tile',
        'Moulded cornice-bricks',
        'Circular and quadrant-shaped bricks for columns',
        'Quadrant-shaped bricks for columns',
        'Circular brick for columns',
        'Roofing-tiles',
        'Bricks',
        'Senior tesserarius',
        'Livius',
        'Stone incised with gladiatorial symbols',
        'Rufinius Primus',
        'Claidius Cupitus',
        'Paetinus',
        'Julius Gemellus',
        'Bath Stone Coffin',
        'Local Pottery',
        'Storage jar',
        'Cup',
        'Bowl',
        'Dish',
        'Field flask',
        'Beaker',
        'Bowl with graffito',
        'Fragment of a company wine-jar',
        'Jug neck',
        'Jug handle with Silenus mask',
        'Flagon',
        'Thuribulum',
        'Beaker',
        'Jug',
        'Bowl',
        'Oil-lamp',
        'Lamp mould',
        'Jug-neck: waster',
        'Lead-glazed bowl',
        'Lead-glazed beaker',
        'Mortarium',
        'Mortarium rim with owners name',
        '',
        '',
        '',
        '',
        'Bowl',
        'Cup',
        'Bowl',
        'Bowl',
        'British Pottery',
        'Flagon',
        'Cooking pot',
        'Jug',
        'Cooking pot',
        'Storage jar',
        'Pot-lid',
        'Jar',
        'Dish and cooking pot',
        'Bowl',
        'Cooking pot',
        'Storage jar',
        'Flagon',
        'Bowl',
        'Rusticated bowl',
        'Bottle',
        'Bowl',
        'Chafing dish',
        '',
        'Mortarium rims with makers stamps',
        'Mortarium rims with makers stamps',
        'Mortarium',
        'Flagon',
        'Roughcast beaker',
        'Beaker',
        'Indented roughcast beaker',
        'Plate',
        'Jug',
        'The Fortress Baths gemstones',
        'Fortress baths',
        'Caerleon gems',
        'Silver ring with red jasper',
        'Alexander the Great',
        'Cameo of Hercules or Omphale',
        'Minerva holding a winged Victory Cornelian, in iron ring',
        '',
        'Roma',
        '',
        '',
        '',
        '',
        'Fortress baths',
        '',
        'Symbols of prosperity',
        'Mercury',
        'Bonus Eventus',
        'Pack-ass',
        'Goat',
        'Minerva',
        '',
        'A combination of Silenus, Bacchus, and an eagle',
        'Mars',
        'Diana the huntress',
        'Eagle devouring a hare',
        'Hero (potentially Achilles)',
        'The Stones',
        'Amethyst',
        'Glass paste (imitating nicolo)',
        'Glass',
        'Sard',
        'Rock crystal',
        'Prase',
        'Citrine',
        'Red jasper',
        'Green jasper',
        'Cornelian',
        'Nicolo',
        'Silver signet ring with an intaglio engraved with a dancing satyr',
        'Furniture and Fittings',
        'Candlesticks',
        '',
        'Bone inlay',
        'Bone hinges from caskets',
        'Iron keys for tumbler locks',
        'Iron keys for tumbler locks',
        'Iron keys for tumbler locks',
        'Keys for rotary locks',
        '',
        'Iron padlock',
        'Keys for rotary locks',
        'Key and lock-bolts, tumbler system',
        'Bronze terminal in the form of a dog',
        'Table legs of Kimmeridge (Dorset) shale',
        '',
        '',
        'Oil-lamps',
        'Iron lamp',
        'Central Gaulish',
        'Central Gaulish',
        'Window glass',
        'Oil-lamps',
        'Locally-made lamps with makers names FORTIS and COMMUNI(S)',
        'Locally-made lamps with makers names FORTIS and COMMUNI(S)',
        'Locally-made lamps with makers names FORTIS and COMMUNI(S)',
        'Locally-made lamps',
        'Locally-made lamps',
        'Locally-made lamps',
        'Locally-made lamps',
        'Bars from a window grille',
        '',
        'Oil lamp in leaden holder',
        '',
        'Glass mosaic-cubes',
        '',
        'Furniture mounting in the form of a Gryphon',
        'Silvered bronze mask of Medusa',
        'Furniture attachments in the form of Medusa masks',
        'Casket handles and fittings',
        '',
        'Casket handles and fittings',
        '',
        'Glassware',
        'Mould-blown bottle',
        '',
        'Inscribed with the makers name',
        'Mould-blown bottle bases with trademarks',
        'Mould-blown bottle bases with trademarks',
        'Coloured glass from 1st century AD',
        'Mould-pressed bowls',
        'Blown cup',
        'Blown flask',
        'Pillar-moulded bowl',
        'Mould-pressed dish and',
        'Flask handles',
        'Emerald flask handles',
        'Flask handles',
        'Flask handle',
        '',
        'Blown flasks',
        'Blown flasks',
        'Blown flasks',
        'Blown perfume bottle',
        '',
        'Facet and figure-cut vessels, 1st-2nd century AD',
        'Facetted beaker',
        'Column capital',
        'Beaker with chariot race',
        'Part of a figure-cut globular bottle',
        '',
        'Engraved gladiator',
        'Mould-blown beaker in the shape of an African head',
        'Mould-blown bottle',
        'Usk - An Early Fortress',
        'Imported Pottery',
        'Bowl, unstamped, but in the style of LAXTUCISSA',
        'Plate by the potter VIDUCUS',
        'Plate',
        'Bowl by the potter MERCATO',
        'Bowl, unstamped, but in the style of DONNAUCUS',
        'Vessels with trailed ivy-leaf decoration',
        '',
        'Vessels with trailed ivy-leaf decoration',
        'Bowl by the potter CRESTIO',
        'Bowl',
        'Bowl by the potter PASSIENUS',
        'Bowl by the potter SEVERUS',
        'Other imported fineware',
        'Central Gaulish lead-glazed ware',
        'Central Gaulish ware with wild boar',
        'Central Gaulish ware dish with trailed leaves',
        'Mortarium',
        'Black-coated samian ware',
        'Black-coated samian ware',
        '',
        'Jar',
        'Cup',
        'Plate by the potters COSLUS and RUFINIUS',
        'Cup with illiterate stamp',
        'Plate',
        'Flanged bowl (Form 38)',
        'Flanged bowl (Form 38)',
        'Cup by the potter ALBUCIUS',
        'Cup by the potter APOLINARIS',
        'Bowl, unstamped, but in the style of DONNAUCUS',
        'Bowl by the potter DIVIXTUS',
        'Burial',
        'Cremation burial in a glass bottle',
        'Lamps made for funerary use',
        'Dedicatory inscription',
        'Cremation burial',
        'Cremation burial',
        'Cremation burial',
        'Glass sprinkler-bottle',
        'Glass perfume bottle',
        '',
        'Samian cup',
        'Amber beads',
        'Food and Drink',
        'Flagon',
        '',
        'Bronze spoons',
        'Silver spoon',
        '',
        'Enamelled bronze knife-handles',
        'Bronze pen-knife',
        'Knife handles of bone and wood',
        'Platter or tray of Kimmeridge (Dorset) shale',
        'Olive-oil amphorae from Spain',
        'Marcus Aemilius Rusticus',
        'Hermes F(ecit)',
        '',
        'Handle of a wine-jar',
        '',
        'Charred grain (Spelt, wheat, barley, rye)',
        'Olive-stone',
        'Date-stone',
        '',
        'Shellfish',
        'Oyster',
        'Scallop',
        'Cockle',
        'Limpet',
        'Bronze fish-hook',
        'Iron cleaver',
        '',
        'Chicken',
        'Sheep',
        'Pig',
        'Hare',
        'Mortarium (food-mixing bowl)',
        'Unleavened loaf',
        'Leaden bread-stamps',
        'Century of Quintinius Aqulia',
        'Century of Vibius Severus',
        '',
        'Samian plate',
        'Side-plate of Kimmeridge',
        '',
        'Tankard-handle',
        'Bowl-handle',
        'Health and Leisure',
        '',
        'Decorated copper strigil (body scraper)',
        'Glass flask for bath-oil',
        'Ivory plaques',
        'Tragic mask',
        'Dancing Maenad and Cupid',
        '',
        'Spindle whorls of pottery',
        'Spindle whorls of Kimmeridge (Dorset) Shale',
        'Bone and bronze weaving tablets',
        'Bone terminals for braid belts',
        'Bronze and bone needles',
        'Bone weaving-comb',
        'Cock-spur',
        'Counters',
        'Stone',
        'Lead',
        'Lead',
        'Samian ware',
        'Bone counters',
        '',
        'Bone and bronze dice',
        'Gaming counters of bone, pottery and glass',
        '',
        'Stone palette for grinding drugs',
        'Bottles for ointment',
        'Childrens milk-teeth',
        'Bone scoops',
        'Bronze scale-pan',
        'Lead scale-weights',
        '',
        'Strigils (body-scrapers) made from shells',
        'Necks and bone stoppers from oil flasks',
        'Bronze razor-handle',
        '',
        'Forceps',
        'Scalpel handle',
        '',
        '',
        'Ear-picks or ointment-scoops',
        'Toilet set',
        'Nail-cleaners',
        'Tweezers',
        'Lead property-marker',
        'Lead baggage-label',
        'Leaden stamp',
        '',
        'Pottery and samian ware inkwells',
        'Lid of a bronze inkwell',
        'Iron stylus',
        'Seal-boxes',
        'Seal-box lid with panther',
        'Weapons used by Roman soldiers.',
        'Pugio',
        'Gladius',
        'Pilum',
        'Tribolus',
        '',
        'No information',
        'Bedroom',
        'Kitchen room',
        'NA - tablet 1',
        'NA - red flag 1',
        'NA - tablet 2',
        'Conquest and Occupation',
        'Caerleon - City of the Legion',
        '_other',
];

const SL_TITLES = [
  'Polar Adventure',
  'Whos who?',
  'Penguin calls',
  'Finding Gentoo around Antartica',
  'Hurricane machine',
  'Polar Bears',
  'Polar Sea Explorers',
  'Game 1.17',
  'Penguin heights',
  'Penguin heights',
  'Welcome to polar adventure (1.20)',
  'Gentoo Penguins',
  'Our Home',
  'Our Experts',
  'Our Day',
  'Our Diet',
  'The Cool Seasons - Its Moulting Time!',
  'Gentoo Penguins',
  'Whos who?',
  'Interesting facts!',
  'Fascinating Marine Species: Lobster, Bream, and Shark',
  'Fascinating Marine Species: Lobster, Bream, and Shark',
  'Gilt-head bream',
  'Were Eel Enthusiasts',
  'Were Ocean Allies',
  'Discover More Local Projects',
  'Fact: Were old!',
  'Game 2.12',
  'We are Seal Supporters',
  'We are Treasuring Turtles',
  'We are Seahorse Saviours',
  'We are Safeguarding Zebra Sharks',
  'We are Reef Rescuers',
  'Shark tank (2.14.1)',
  'Shark tank (2.14.2)',
  'Shark tank (2.14.3)',
  'Making Waves Across The Globe',
  'Here at SEA LIFE',
  'Donate Today',
  'Are you having a turtle-y awesome day with us?',
  'Display 2.2',
  'Plastic in Everyday Life',
  'Golden damselfish & Cleaner Wrasse',
  'Golden Damselfish',
  'Cleaner Wrasse',
  'Ten Tips for living with less plastic',
  'Discover eight different species of fish!',
  'Picasso Tiggerfish',
  'Stripped Burrfish',
  'Cleaner Wrasse',
  'Yellowtail Damselfish',
  'Humbug Damselfish',
  'Valentins sharpnose puffer',
  'Little Grey and Little White',
  'Walls',
  'Help Our Sea Friends',
  'Our Vision',
  'We are Seal Supporters',
  'Conservation Evenings',
  'We are Whale Warriors',
  'Conservation Cove',
  'Welcome to Conservation Cove',
  'Beluga Whales ',
  'Fact:',
  'Fact:',
  'SEA LIFE TRUST',
  'A delicate balance',
  'Ocean Invaders Game',
  'Upside-Down Jellyfish',
  'Upside-Down Jellyfish',
  'Grand illuminations!',
  'Global domination',
  'Japanese Sea Nettle',
  'Japanese Sea Nettle',
  'Japanese Sea Nettle',
  'Japanese Sea Nettle',
  'Japanese Sea Nettle',
  'Pacific Sea Nettle',
  'Pacific Sea Nettle',
  'Floating bell (Australian spotted jellyfish)',
  'Floating bell (Australian spotted jellyfish)',
  'Unknown 3.18.1',
  'Unknown 3.18.2',
  'Unknown 3.18.3',
  'Artemia Brine Shrimp',
  'Moon Jellyfish',
  'Moon Jellyfish',
  'Moon Jellyfish Polyp',
  'Moon Jellyfish Polyp',
  'Moon Jellyfish',
  'Do these look like jellyfish?',
  'The largest lions mane jellyfish recorded was 37 metres long!',
  'Barrel Jellyfish',
  'Barrel Jellyfish',
  '',
];

const MT_TITLES = [
    'Drake',
    'Jimi Hendrix',
    'Amy Winehouse',
    'Miley Cyrus',
    'Lady Gaga',
    'Bob Marley',
    'Timothee Chalamet',
    'Leonardo DiCaprio',
    'Brad Pitt',
    'Priyanka Chopra Jonas',
    'Shah Rukh Khan',
    'Ariana Grande',
    'Mo Salah',
    'Kylie Minogue',
    'Justin Bieber',
    'Madonna',
    'Royal Corgi',
    'will.i.am',
    'The Beatles',
    'John Lennon',
    'Ringo Starr',
    'Paul McCartney',
    'George Harrison',
    'Dua Lipa',
    'David Bowie',
    'Little Mix',
    'Leigh-Anne Pinnock',
    'Jesy Nelson',
    'Perrie Edwards',
    'Jade Thirlwall',
    'Freddie Mercury',
    'Taylor Swift',
    'Ed Sheeran',
    'Beyonce',
    'End of app experience',
    'other',
];

const TT_TITLES = [
];

const RAMM_TITLES = [
];

const NMC_TITLES = [
];


const locationConfig = {
  RLM: { categories: RLM_CATEGORIES, titles: RLM_TITLES },
  SL: { categories: SL_CATEGORIES, titles: SL_TITLES },
  MT: { categories: MT_CATEGORIES, titles: MT_TITLES },
  TT: { categories: TT_CATEGORIES, titles: TT_TITLES },
  RAMM: { categories: RAMM_CATEGORIES, titles: RAMM_TITLES },
  NMC: { categories: NMC_CATEGORIES, titles: NMC_TITLES }
}[LOCATION];

if (!locationConfig) {
  throw new Error(`Invalid REACT_APP_LOCATION: ${LOCATION}. Must be one of RLM, SL, MT, TT, RAMM, or NMC.`);
}

export const CATEGORIES = locationConfig.categories;
export const TITLES = locationConfig.titles;

export { RLM_Cabinet_CATEGORIES };
export { RLM_orangepot_CATEGORIES };
export { RLM_blackpot_CATEGORIES };
export { RLM_figure_CATEGORIES };
export { RLM_signage_CATEGORIES };